import type { Registry as Services } from '@ember/service';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { tKey } from 'ember-intl';
import {
  MI_DEFAULT_DATE_FORMAT,
  PARTIAL_DATE_FORMATS,
} from 'lumen/utils/constants/general-constants';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function isWeek(startDate: Dayjs, endDate: Dayjs) {
  if (startDate && endDate) {
    // Check if startDate is a Monday (ISO 1) and endDate is a Sunday (ISO 7) and there is a 6 day difference between the two days
    return (
      startDate.isoWeekday() === 1 &&
      endDate.isoWeekday() === 7 &&
      endDate.diff(startDate, 'day') === 6
    );
  }

  return null;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function isMonth(startDate: Dayjs, endDate: Dayjs) {
  if (startDate && endDate) {
    const startOfMonth = startDate.startOf('month');
    const endOfMonth = startDate.endOf('month');
    return (
      startDate.isSame(startOfMonth, 'day') && endOfMonth.isSame(endDate, 'day')
    );
  }

  return null;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function dateRangeDisplay(
  start: Dayjs,
  end: Dayjs,
  intl: Services['intl'],
) {
  let res = '';

  if (start || end) {
    if (isWeek(start, end)) {
      return intl.t(tKey('general.week_of'), {
        date: start.format(MI_DEFAULT_DATE_FORMAT),
      });
    }
    if (isMonth(start, end)) {
      const locale = dayjs().locale() as keyof typeof PARTIAL_DATE_FORMATS;
      res += start.format(PARTIAL_DATE_FORMATS[locale].YEAR_AND_MONTH_LONG);
    } else if (
      start &&
      end &&
      start.format(MI_DEFAULT_DATE_FORMAT) ===
        end.format(MI_DEFAULT_DATE_FORMAT)
    ) {
      res += start.format(MI_DEFAULT_DATE_FORMAT);
    } else if (start) {
      res += start.format(MI_DEFAULT_DATE_FORMAT);
      if (end) {
        res += ` - ${end.format(MI_DEFAULT_DATE_FORMAT)}`;
      }
    } else if (end) {
      res += end.format(MI_DEFAULT_DATE_FORMAT);
    }
  }

  return res;
}
